import { render, staticRenderFns } from "./RiskScore.vue?vue&type=template&id=01d40e38&scoped=true"
import script from "./RiskScore.vue?vue&type=script&lang=js"
export * from "./RiskScore.vue?vue&type=script&lang=js"
import style0 from "./RiskScore.vue?vue&type=style&index=0&id=01d40e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d40e38",
  null
  
)

export default component.exports